import React, { FC, useMemo } from 'react'

import styled from 'styled-components'

import { TimeRange } from 'common-constants/timeRange'
import { BadgeDeleting } from 'components/block/badge/deleting/BadgeDeleting'

import { useGetDaysAndTimeLeft } from '../Chat/Messenger/MessengerChatAutoDeletePopUp/MessengerChatAutoDeletePopUp.hooks'

export const ContactBadge: FC<{ autoDeleteDate: number; id: number }> = ({
  id,
  autoDeleteDate,
}) => {
  const { days, hours } = useGetDaysAndTimeLeft(
    autoDeleteDate * TimeRange.second
  )

  /**
   * hours +1
   * https://youtrack.mamba.ru/issue/M-3934
   */
  const width = useMemo(
    () => ((hours! + 1) * TimeRange.hour * 100) / TimeRange.day,
    [hours]
  )

  if (days! > 0) {
    return null
  }

  return (
    <ContactBadgeDeleting
      width={width}
      data-name={`contact-item-badge-delete-${id}`}
    />
  )
}

const ContactBadgeDeleting = styled(BadgeDeleting)`
  margin-bottom: 5px;
`
